// extracted by mini-css-extract-plugin
export default {"inputRoot":"button-storeIn-cloud_inputRoot__p9HW-","inputWrapper":"button-storeIn-cloud_inputWrapper__WeaT3","icon":"button-storeIn-cloud_icon__R7bUh"};